/* eslint-disable @typescript-eslint/ban-types */
import fr from "@/locales/fr.json";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type TFunctionType = keyof typeof fr;
const useTypedTranslation = () => {
  const { t } = useTranslation<TFunctionType>();
  return useMemo(() => {
    return {
      t: (key: TFunctionType, params?: {}) => {
        return t(key, params);
      },
    };
  }, [t]);
};

export default useTypedTranslation;
